import { render, staticRenderFns } from "./UploadAreaInput.vue?vue&type=template&id=4221c10c&scoped=true&"
import script from "./UploadAreaInput.vue?vue&type=script&lang=js&"
export * from "./UploadAreaInput.vue?vue&type=script&lang=js&"
import style0 from "./UploadAreaInput.vue?vue&type=style&index=0&id=4221c10c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4221c10c",
  null
  
)

export default component.exports